import Icon from '../../../components/AppIcon';

const WhyChooseUs = () => {
  const benefits = [
    {
      icon: "Award",
      title: "30+ Years Experience",
      description: "Three decades of proven expertise in plumbing and electrical services"
    },
    {
      icon: "Users",
      title: "Trusted by Major Brands",
      description: "McDonald's, KFC, and other commercial clients rely on our expertise"
    },
    {
      icon: "Clock",
      title: "Fast Response Times",
      description: "Average 30-45 minute response for emergency calls"
    },
    {
      icon: "Shield",
      title: "Licensed & Certified",
      description: "Qualified professionals with relevant trade certifications"
    },
    {
      icon: "ThumbsUp",
      title: "Quality Guaranteed",
      description: "All work backed by comprehensive warranties"
    },
    {
      icon: "DollarSign",
      title: "Fair Pricing",
      description: "Transparent quotes with no hidden fees or surprises"
    }
  ];

  return (
    <div className="bg-gradient-to-br from-primary to-secondary text-primary-foreground rounded-lg p-6 md:p-8 shadow-elevated">
      <div className="text-center mb-6 md:mb-8">
        <h2 className="font-headline font-bold text-2xl md:text-3xl lg:text-4xl mb-3">
          Why Choose meriodine?
        </h2>
        <p className="font-body text-sm md:text-base lg:text-lg opacity-90 max-w-2xl mx-auto">
          When you need reliable plumbing and electrical services, experience matters. Here's why customers trust us.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {benefits?.map((benefit, index) => (
          <div
            key={index}
            className="bg-primary-foreground/10 backdrop-blur-sm rounded-lg p-4 md:p-6 hover:bg-primary-foreground/20 transition-all duration-300"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 bg-accent text-accent-foreground rounded-full flex items-center justify-center mb-4">
              <Icon name={benefit?.icon} size={24} />
            </div>

            <h3 className="font-headline font-semibold text-lg md:text-xl mb-2">
              {benefit?.title}
            </h3>

            <p className="font-body text-sm md:text-base opacity-90">
              {benefit?.description}
            </p>
          </div>
        ))}
      </div>
      <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-primary-foreground/20 text-center">
        <p className="font-body text-sm md:text-base lg:text-lg opacity-90 mb-4">
          Join thousands of satisfied customers who trust meriodine for their service needs
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm md:text-base">
          <div className="flex items-center gap-2">
            <Icon name="CheckCircle" size={20} className="text-accent" />
            <span className="font-accent font-semibold">30+ Years</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;